/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

import FactoryMaker from '../../core/FactoryMaker.js';
import Constants from '../constants/Constants.js';
import Utils from '../../core/Utils.js';

function CommonAccessTokenController() {

    let instance,
        hostTokenMap;

    function processResponseHeaders(httpResponse) {
        if (!httpResponse || !httpResponse.headers || !httpResponse.request || !httpResponse.request.url) {
            return
        }

        const commonAccessTokenHeader = httpResponse.headers[Constants.COMMON_ACCESS_TOKEN_HEADER]
        if (commonAccessTokenHeader) {
            const host = Utils.getHostFromUrl(httpResponse.request.url)
            if (host) {
                hostTokenMap[host] = commonAccessTokenHeader
            }
        }
    }

    function getCommonAccessTokenForUrl(url) {
        if (!url) {
            return null
        }

        const host = Utils.getHostFromUrl(url);
        if (host) {
            return hostTokenMap[host] ? hostTokenMap[host] : null;
        }
    }

    function setup() {
        _resetInitialSettings();
    }

    function reset() {
        _resetInitialSettings()
    }

    function _resetInitialSettings() {
        hostTokenMap = {}
    }

    instance = {
        reset,
        processResponseHeaders,
        getCommonAccessTokenForUrl
    };

    setup();
    return instance;
}

CommonAccessTokenController.__dashjs_factory_name = 'CommonAccessTokenController';
export default FactoryMaker.getSingletonFactory(CommonAccessTokenController);
